module.exports = __webpack_public_path__ + "static/8-6d973fe42e1620c9022935e40f990d39.jpeg";